import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseModalComponent } from '@app/components/base-modal/base-modal.component';
import { ArticleReferenceCreate } from '../../../models/article-reference-create.model';
import { IncidentDetailsPageStore } from '../../../incident-details-page.store';
import { urlSyntaxValidator } from '@app/shared/form-validations';

@Component({
  standalone: true,
  selector: 'app-article-reference-modal',
  imports: [
    MatButtonModule,
    MatDialogModule,
    FormsModule,
    BaseModalComponent,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './add-article-reference-modal.component.html',
  styleUrl: './add-article-reference-modal.component.scss',
})
export class AddArticleReferenceModalComponent {
  protected formGroup: FormGroup;

  constructor(
    private readonly dialogRef: MatDialogRef<AddArticleReferenceModalComponent>,
    private readonly formBuilder: FormBuilder,
    protected readonly store: IncidentDetailsPageStore,
  ) {
    this.dialogRef.disableClose = true;

    this.formGroup = this.formBuilder.group({
      name: [null],
      url: [
        null,
        [Validators.required, urlSyntaxValidator, AddArticleReferenceModalComponent.urlUniquenessValidator(this.store)],
      ],
    });
  }

  protected onContinue(): void {
    const value: ArticleReferenceCreate = {
      name: this.formGroup.value.name,
      url: this.formGroup.value.url,
    };

    this.dialogRef.close(value);
  }

  protected onCancel(): void {
    this.dialogRef.close(false);
  }

  private static urlUniquenessValidator(store: IncidentDetailsPageStore): ValidationErrors | null {
    return (control: AbstractControl) => {
      if (!control.value) return null;

      const formUrl = control.value.trim().toLowerCase();
      const alreadyExists = store
        .allArticleReferences()
        .some((articleReference) => articleReference.url.trim().toLowerCase() === formUrl);

      return alreadyExists ? { nonUniqueUrl: true } : null;
    };
  }
}
